import { FormikErrors } from "formik";

export const renderFieldError = (
  errors: FormikErrors<{ [key: string]: string }>,
  fieldName: string
) => {
  return (
    <div className="text-red-500">
      {errors[fieldName] || <span className="text-white">A</span>}
    </div>
  );
};
